// Polyfill URL.parse for browsers that don't support it (Chrome < 126).
// URL.parse() is a static method that returns null on invalid URLs instead of
// throwing, unlike `new URL()`. Third-party libraries (e.g. pdfjs-dist) use it,
// so browsers without it crash at render time.
if (!URL.parse) {
  URL.parse = (url, base) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

// Polyfill Promise.withResolvers for browsers that don't support it
// (Safari < 17.4, Chrome < 119, Firefox < 121). It's an ES2024 API that
// pdfjs-dist uses during PDF rendering, so older browsers (e.g. iOS 15
// Mobile Safari) throw "Promise.withResolvers is not a function" and crash
// the page at render time. Returns { promise, resolve, reject } per spec.
if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

